import { GoogleAuthProvider, signInWithRedirect } from 'firebase/auth'
import { auth } from './firebase.service'

const provider = new GoogleAuthProvider();

export const loginWithGoogle = async () => {
  return await signInWithRedirect(auth, provider)
}
